import axios from "axios";

const productionHosts = ["dr-rentals.be", "www.dr-rentals.be"];

const defaultApiBaseUrl = typeof window !== "undefined" && productionHosts.includes(window.location.hostname)
  ? "https://api.dr-rentals.be/api"
  : "/api";

const normalizeApiBaseUrl = (value) => {
  const trimmed = String(value || "").trim().replace(/\/$/, "");

  try {
    const url = new URL(trimmed);

    if (url.pathname === "" || url.pathname === "/") {
      url.pathname = "/api";
      return url.toString().replace(/\/$/, "");
    }
  } catch {
    return trimmed || "/api";
  }

  return trimmed || "/api";
};

export const API_BASE_URL = normalizeApiBaseUrl(process.env.REACT_APP_API_URL || defaultApiBaseUrl);
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || API_BASE_URL.replace(/\/api\/?$/, "");

const API = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true
});

const isValidStoredJwt = (token) => {
  if (!token || typeof token !== "string" || token.split(".").length !== 3) {
    return false;
  }

  try {
    const base64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const payload = JSON.parse(atob(base64.padEnd(base64.length + (4 - base64.length % 4) % 4, "=")));
    return !payload.exp || payload.exp * 1000 > Date.now();
  } catch {
    return false;
  }
};

const clearStoredAuth = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
};

const shouldLogAdminAuth = (url = "") => (
  url.startsWith("/admin/checkouts") ||
  url.startsWith("/admin/checkins") ||
  url.startsWith("/admin/settlements")
);

// attach token automatically
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (shouldLogAdminAuth(config.url)) {
    console.log("[auth] admin request:", config.url, "tokenExists:", Boolean(token));
  }

  if (isValidStoredJwt(token)) {
    config.headers.Authorization = `Bearer ${token}`;
  } else if (token) {
    clearStoredAuth();
  }

  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    const isLoginRequest = error.config?.url === "/auth/login";

    if (!isLoginRequest && error.response?.status === 401) {
      clearStoredAuth();

      if (window.location.pathname.startsWith("/admin")) {
        window.location.assign("/login");
      }
    }

    return Promise.reject(error);
  }
);

export default API;
